import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';
import type { AdminAudience } from '@/api/types';

export const nimAnnouncementKeys = {
  all: ['nim-announcements'] as const,
  list: (params: Record<string, string | number | undefined>) =>
    [...nimAnnouncementKeys.all, 'list', params] as const,
};

export function useNimAnnouncements(params: { limit?: number; offset?: number } = {}) {
  return useQuery({
    queryKey: nimAnnouncementKeys.list(params),
    queryFn: () => adminClient.listNimAnnouncements(params),
    // delivered_count grows as users open conversations; poll so the table
    // reflects progress without a manual refresh.
    refetchInterval: 15_000,
  });
}

export function useCreateNimAnnouncement() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      content: string;
      audience?: AdminAudience;
      idempotencyKey: string;
      buttonLabel?: string;
      buttonUri?: string;
    }) => adminClient.createNimAnnouncement(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: nimAnnouncementKeys.all });
    },
  });
}

export function useCancelNimAnnouncement() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminClient.cancelNimAnnouncement(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: nimAnnouncementKeys.all });
    },
  });
}
